module.exports = __webpack_public_path__ + "img/verf-groen.2ce67dd2.jpeg";